import styled from "@emotion/styled";

const SummaryHeader = styled.h3`
    font-size: 16px;
    font-weight: bold;
    line-height: 0;
`;

export default SummaryHeader;
